<template>
  <b-button @click="$emit('click')">
    <font-awesome-icon
      v-if="icon"
      :icon="icon"
    />
    <div
      v-else
      class="font-weight-bold text-monospace"
    >
      {{ operator }}
    </div>
  </b-button>
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'
import { FieldCalculationOperatorTypes, FieldCalculationOperatorType } from '@/types'

const ICONS = {
  [FieldCalculationOperatorTypes.PLUS]: 'plus',
  [FieldCalculationOperatorTypes.MINUS]: 'minus',
  [FieldCalculationOperatorTypes.MULTIPLY]: 'times',
  [FieldCalculationOperatorTypes.DIVIDE_BY]: 'divide',
  [FieldCalculationOperatorTypes.OPEN_PARENTHESIS]: null,
  [FieldCalculationOperatorTypes.CLOSE_PARENTHESIS]: null,
}

const props = {
  operator: {
    type: String as PropType<FieldCalculationOperatorType>,
    required: true,
  },
}

@Component
export default class FieldOperator extends Vue.extend({ props }) {
  get icon () {
    return ICONS[this.operator]
  }
}

</script>
